import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/deal/$dealId/_layout/_index/')({
  component: () => null
});